import React, { useState } from 'react';

import {
  AvailablePieceJointeDto,
  ComputedResponseDtoListAvailableFilesEnum,
} from 'lib_api/lib/api/gen';

import { useDownloadDocument } from 'hooks/dossiers/useDownloadDocument';
import { useDownloadPieceJointe } from 'hooks/dossiers/useDownloadPieceJointe';

import AvailableFilesDropdown from './components/AvailableFilesDropdown';
import SingleAvailableFile from './components/SingleAvailableFile';

interface AvailableFilesProps {
  dossierId: string;
  files: Set<ComputedResponseDtoListAvailableFilesEnum>;
  piecesJointes: AvailablePieceJointeDto[];
  deletePieceJointe?: (pieceJointe: AvailablePieceJointeDto) => void;
}

const AvailableFiles = ({
  files,
  piecesJointes,
  dossierId,
  deletePieceJointe,
}: AvailableFilesProps): React.ReactElement => {
  const [isWaiting, setIsWaiting] = useState<boolean>(false);

  const downloadDocument = useDownloadDocument(setIsWaiting, dossierId);
  const downloadPieceJointe = useDownloadPieceJointe(setIsWaiting, dossierId);

  if (files.size === 0 && piecesJointes.length === 0) {
    return <></>;
  }

  if (files.size === 1 && piecesJointes.length === 0) {
    return (
      <SingleAvailableFile
        file={[...files][0]}
        downloadDocument={downloadDocument}
        isDownloading={isWaiting}
      />
    );
  }

  return (
    <AvailableFilesDropdown
      files={files}
      piecesJointes={piecesJointes}
      downloadPieceJointe={downloadPieceJointe}
      deletePieceJointe={deletePieceJointe}
      downloadDocument={downloadDocument}
      isWaiting={isWaiting}
    />
  );
};

export default AvailableFiles;
